module.exports = __webpack_public_path__ + "img/down.8a1186b5.png";